// Pure functions only in helpers, please

import config from 'config'

export const getPostBackgrounds = postData => {
  const backgroundImages = ((postData || {}).fields || {}).background_images

  if (!Array.isArray(backgroundImages)) return null
  const images = backgroundImages
    .filter(image => {
      return !!((image.background_image || {}).sizes || {})['1536x1536']
    })
    .map(images => images.background_image.sizes['1536x1536'])

  return images
}

export const formatTitle = (title, siteName) => {
  let output = [siteName || config.siteName || '']

  if (title) {
    output = [title, ...output]
  }

  return output.join(' | ')
}

export const trimExcerpt = (excerpt, characterLength = 80) => {
  const trimmed = excerpt
    .replace(/\s+\[&hellip;\]$/g, '')
    .slice(0, characterLength)
    .trim()

  return `${trimmed}...`
}
